/**
 * Module-level store for Word files selected from the onboarding Import CTA.
 *
 * Why: browsers block <input type="file"> activation unless it originates from a
 * trusted user gesture. The onboarding CTA captures the file selection on the
 * source page (within the DropdownItem click — a real gesture), stores the files
 * here, then navigates. ImportFromLocal reads and clears the store on mount,
 * bypassing pickDocument() entirely and going straight to onDocumentSelect().
 *
 * This variable is intentionally module-scoped (not React state) so it survives
 * client-side navigation without being serialised to the URL or sessionStorage.
 */
let pendingFiles: File[] | null = null;

export const setPendingWordFiles = (files: File[]): void => {
	pendingFiles = files;
};

export const getPendingWordFiles = (): File[] | null => pendingFiles;

export const clearPendingWordFiles = (): void => {
	pendingFiles = null;
};
